import { useContext } from "react";
import { FormattedMessage } from "react-intl";

import { RanaHeading } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { BasePage } from "@/components/base-page";
import { TenantProjectList } from "@/features/project";
import { useTenantQuery } from "@/queries/query-tenant";

export function TenantProjectsPage() {
  const tenantResponse = useTenantQuery();
  const { tenant } = useContext(TenantContext);
  const tenantName = tenantResponse.data ? tenantResponse.data.name : tenant;

  return (
    <BasePage
      activeSidebarButton="projects"
      pageSubTitle={<FormattedMessage id="page_title.projects" defaultMessage="Projects" />}
    >
      <RanaHeading type="h1" addDot>
        <FormattedMessage
          id="heading.projectsFor"
          defaultMessage="Projects for {name}"
          values={{ name: tenantName }}
        />
      </RanaHeading>
      <TenantProjectList />
    </BasePage>
  );
}
